import { ACTIONS } from '@~/actions/notification';

const initialState = {
  avatarUrl: null,
  Component: null,
  duration: null,
  props: null,
  showTeacherAvatar: false,
  text: null,
  visible: false,
};

export default function defaultExport(state = initialState, { type, payload }) {
  switch (type) {
    case ACTIONS.SHOW_NOTIFICATION: {
      return {
        ...payload,
        visible: true,
      };
    }
    case ACTIONS.HIDE_NOTIFICATION: {
      return initialState;
    }
    default:
      return state;
  }
}
